export default function assetDirective() {
  return {
    template: require('./asset.html'),
    restrict: 'E',
    controller: 'AssetController',
    controllerAs: 'assetVM',
    bindToController: true,
    replace: true,
    scope: {
      asset: '=',
      assignAsset: '<',
      tooltipAppendToSelector: '@',
      assessmentAsset: '<',
      isEditProcessDialog: '<',
      isApproveProcessDialog: '<',
      isPraProcessMain: '<',
      process: '<',
      showType: '<',
      showCriticality: '<',
      showDataUsage: '<',
      showNotes: '<',
      showRiskCount: '<',
      showRiskControlCount: '<',
      showActionIcons: '<',
      assetType: '<',
      showBulkDelete: '<',
      showBulkChangeType: '<',
      showSyncAsset: '<'
    },
  };
}
